module.exports = __webpack_public_path__ + "static/img/brees-2013-slide-8.52d9ddb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-slide-8.jpg
// module id = +I6S
// module chunks = 1